import { jsx as e } from "react/jsx-runtime";
import o from "@mui/joy/Checkbox";
import { FormField as r } from "../FormField.js";
const l = ({ control: l2, name: n, label: i, preview: a = false, required: t, disabled: m = false }) => e(r, { control: l2, name: n, preview: a, required: t, customPreviewRender: true, children: ({ name: r2, onChange: n2, onBlur: t2 }) => {
  var _a;
  return e(o, { name: r2, label: i, size: "sm", variant: "outlined", color: "neutral", checked: ((_a = l2.values) == null ? void 0 : _a[r2]) || false, onChange: n2, onBlur: t2, disabled: a || m, sx: { "&:not(.Mui-disabled) .MuiCheckbox-label": { fontWeight: 500, color: (e2) => e2.palette.neutral[700] } } });
} });
export {
  l as CheckboxField
};
//# sourceMappingURL=CheckboxField.js.map
